import ContactUs from '@ictlife/core/components/contact-us/ContactUs';
import BrandLayout from '@ictlife/merchant/components/brand/BrandLayout';
import Head from 'next/head';

const ContactUsPage = () => {
  return (
    <BrandLayout>
      <Head>
        <title>AfricaSasa Events | Contact Us</title>
      </Head>
      <ContactUs />
    </BrandLayout>
  );
};

export default ContactUsPage;
